import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import Navbar from '../components/Navbar';
import Slider from '../components/Slider';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

import Image3 from "../images/slider/3.jpg";
import Image4 from "../images/slider/4.jpg";
import { properties } from '../lib/data';
import { nigerianCurrency } from '../lib/formatter';

const IMAGES = [Image3, Image4];

const RealEstatePage = () => {
    const home = useRef(null);
    const location = useLocation();

    useEffect(() => {
        if (location.hash === '#home' && home.current) {
            home.current.scrollIntoView({ behaviour: "smooth" })
        }
    })
    return (
        <div>
            {/* Navigation */}
            <Navbar />

            {/* start home */}
            <section id="home" ref={home}>
                <div className="overlay">
                    <Slider imageUrls={IMAGES} realEstate />
                </div>
            </section>
            {/* end home  */}


            {/* start body-wrap  */}
            <section id="body-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 wow bounceIn">
                            <h2 className="text-uppercase">REAL ESTATE</h2>
                            <hr />
                            <h4 className='contact-style'>Contact us for all your real estate needs. Please see below properties for sale...</h4>
                        </div>
                    </div>

                    <hr style={{ width: "100%", marginBottom: "20px", marginTop: 0 }} />
                    {
                        properties && properties.map(property => (
                            <>
                                <div className="row">
                                    <div className="col-md-6 col-sm-6 wow fadeInLeft brainytech-about-left" data-wow-delay="0.3s">
                                        <img className="img-responsive img-rounded" alt='property' src={`${process.env.PUBLIC_URL}${property.imgURL}`} style={{ margin: "auto" }} />
                                    </div>
                                    <div className="col-md-6 col-sm-6 wow fadeInRight pull-left" data-wow-delay="0.3s">
                                        <p><span className="blue titled">TITLE:</span> <b style={{ textTransform: 'uppercase' }}>{property.title}</b></p>
                                        <p><span className="blue titled">DESCRIPTION:</span>{property.desc}</p>
                                        <p><span className="blue titled">LOCATION:</span> {property.location} </p>
                                        <p>
                                            <span className="blue titled">PRICE:</span>
                                            <span style={{ display: "flex", flexDirection: 'row', fontWeight: 'bold', alignItems: 'start', marginTop: '-10px' }}>
                                                <span style={{ marginRight: 7 }}> {nigerianCurrency.format(property.price)}</span>
                                                <span className='capital'>({property.priceInWords})</span>
                                            </span>
                                        </p>
                                        <p>
                                            <span className="blue titled">STATUS: </span>
                                            <span style={{ textTransform: 'uppercase', fontWeight: 'bold' }}>{property.status}</span>
                                        </p>
                                        <p className="text-center"> <a href="#">(View more pictures)</a></p>
                                    </div>

                                </div>
                                <hr style={{ width: "100%", margin: "20px 0" }} />
                            </>

                        ))
                    }
                </div>

            </section >
            {/* end body-wrap  */}

            {/* contact  */}
            <Contact />

            {/* Footer */}
            <Footer />
        </div >
    )
}

export default RealEstatePage